/**
 * Configuración de los tres proyectos PostHog:
 * - Psicólogo UAT/local: eventos del psicólogo en entornos no producción
 * - Psicólogo Prod: eventos del psicólogo en app.mential.io (via proxy)
 * - Paciente Prod: woman-onboarding, pago, evaluación, etc. solo en prod (via proxy)
 *
 * Sustituir los placeholders por los tokens reales de cada proyecto.
 */
const isProduction = typeof window !== 'undefined' && window.location.href.indexOf('app.mential.io') > -1;

export const POSTHOG_PROXY = 'https://t.mential.io';
export const POSTHOG_EU_HOST = 'https://eu.i.posthog.com';

/** Token proyecto Psicólogo UAT (y local). Ej: mismo que tenías para dev (131912) o uno dedicado. */
export const POSTHOG_PSYCHOLOGIST_UAT_TOKEN = process.env.REACT_APP_POSTHOG_PSYCHOLOGIST_UAT_TOKEN || 'phc_k00p9M7zcLPGbEqLlheLN3t4qPQcTBz4O6lKuydGOGO';

/** Token proyecto Psicólogo Prod (Project ID 131978, EU Cloud). */
export const POSTHOG_PSYCHOLOGIST_PROD_TOKEN = process.env.REACT_APP_POSTHOG_PSYCHOLOGIST_PROD_TOKEN || 'phc_a3CWTH3By0npO0EEUKmbQ5hXIR2mRC6T1yZfomHn8lg';

/** Token proyecto Paciente/resto Prod (woman-onboarding, pago, evaluación, etc.). Via proxy. */
export const POSTHOG_PATIENT_PROD_TOKEN = process.env.REACT_APP_POSTHOG_PATIENT_PROD_TOKEN || 'phc_JlOOhHNdARMbmaH4Tpx4yzGAJ4ehGvuBxuIetHqBCAa';

export function getPsychologistPostHogConfig() {
  return {
    apiKey: isProduction ? POSTHOG_PSYCHOLOGIST_PROD_TOKEN : POSTHOG_PSYCHOLOGIST_UAT_TOKEN,
    api_host: isProduction ? POSTHOG_EU_HOST : POSTHOG_EU_HOST,
    isProduction,
  };
}

export function getPatientPostHogConfig() {
  return {
    apiKey: POSTHOG_PATIENT_PROD_TOKEN,
    api_host: POSTHOG_PROXY,
    onlyInProduction: true,
  };
}

export { isProduction };
